import React from 'react';

import MessagePropType from '../definitions/MessagePropType';
import { MessageBannerVariants } from '../definitions/MessageBannerDefinitions';
import MessageBanner from './MessageBanner';


function MessageBannerSuccess({ message, ...otherProps }) {
    return (
        <MessageBanner
            iconKey="checkmark"
            variant={MessageBannerVariants.SUCCESS}
            message={message}
            {...otherProps}
        />
    );
}

MessageBannerSuccess.propTypes = {
    message: MessagePropType.isRequired,
};

export default MessageBannerSuccess;
